<script>
  import { createEventDispatcher } from 'svelte';
  import { goto } from '$app/navigation';

  import Track from '@utils/track';

  import Modal from '@components/Modal.svelte';
  import GroupIdeasBuilder from '@app-components/group_ideas/GroupIdeasBuilder.svelte';

  import AddRecExternalModal from '@app-components/modal/AddRecExternalModal.svelte';

  import GroupAjax from '@ajax/group';
  import RecAjax from '@ajax/rec';

  const dispatch = createEventDispatcher();

  export let showModal = false;
  export let mobile = false;
  export let currentUser;

  let showBuilder = false;
  let showAddRecExternalModal = false;
  let searchTerm;
  let selectedIdea;
  let selectedCategory;

  let close = function () {
    dispatch('close');
    showModal = false;
  };

  let createBlankGroup = function () {
    dispatch('create-group', { name: 'My new list' });
    close();
  };

  let showListIdeas = function () {
    showBuilder = true;
    Track.generatedListStartFromListIdeas({ currentUser: currentUser });
  };

  let closeBuilder = function () {
    showBuilder = false;
  };

  let displayAutofill = async function (st) {
    searchTerm = st;
    showAddRecExternalModal = true;
  };

  let createGroup = async function (idea) {
    let group = await GroupAjax.create({
      name: idea.title,
      description: idea.data.description,
      idea_group: true,
      idea_group_topics: idea.data.categories,
    });

    goto(group.url + '?show_sections=false');
  };

  let createGroupAndRec = async function (recData) {
    try {
      let remainingCategories = selectedIdea.data.categories.filter((c) => c != selectedCategory);

      let group = await GroupAjax.create({
        name: selectedIdea.title,
        description: selectedIdea.data.description,
        idea_group: true,
        idea_group_topics: remainingCategories,
      });

      recData['rec'] = { ...recData['rec'], idea_generated: true };
      let rec = await RecAjax.create(group, recData);

      return {
        rec: rec,
        group: group,
      };
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
        });
      }
    }
  };
</script>

<style style="text/scss" lang="scss">
  .add-group-or-idea-content {
    width: 100%;
    display: flex;
    gap: 16px;

    .add-group-or-idea-btn {
      border-radius: 16px;
      border: 2px solid var(--Neutral-Input-gray, #ececec);
      background: var(--Neutral-White, #fff);
      height: 168px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 16px;
      font-weight: 500;
      flex-direction: column;
      gap: 17px;
      text-align: center;
      cursor: pointer;

      &:hover {
        border: 2px solid #a893f9;
        background-color: #eae4ff;
      }

      .add-group-or-idea-popular {
        font-size: 10px;
        font-style: normal;
        font-weight: 700;
        color: #2caf87;
        letter-spacing: 0.8px;
        text-transform: uppercase;
        padding-top: 2px;
      }
    }
  }

  * :global(.group-ideas-builder-header) {
    margin-top: -60px;
  }

  * :global(.selected-idea-back) {
    margin-top: 4px;
  }

  * :global(.mobile > .selected-idea-back) {
    left: 0px !important;
  }
</style>

{#if showAddRecExternalModal}
  <AddRecExternalModal
    skipStepOne={true}
    name={searchTerm}
    bind:showModal={showAddRecExternalModal}
    mobile={mobile}
    createGroupAndRec={createGroupAndRec}
    on:added={(e) => {
      if (e.detail && e.detail.group) {
        goto(e.detail.group.url);
      }

      close();
    }} />
{/if}

{#if showBuilder}
  <div class="svelte-modal">
    <Modal
      mobile={mobile}
      on:close={closeBuilder}
      show={showBuilder}
      showCloseButton={true}
      fadeInDuration={200}
      style="border-radius: 16px; width: 510px">
      <div slot="content">
        <GroupIdeasBuilder
          mobile={mobile}
          currentUser={currentUser}
          on:back={closeBuilder}
          displayAutofill={displayAutofill}
          bind:selectedIdea={selectedIdea}
          bind:selectedCategory={selectedCategory}
          on:create-list={(e) => {
            createGroup(e.detail.idea);
          }} />
      </div>
    </Modal>
  </div>
{/if}

<div class="svelte-modal">
  <Modal
    mobile={mobile}
    on:close={close}
    show={showModal}
    showCloseButton={false}
    fadeInDuration={200}
    style="border-radius: 16px; width: 490px;">
    <div slot="content">
      <div class="add-group-or-idea-content">
        <div class="add-group-or-idea-btn" style="padding-top: 13px;" on:click={showListIdeas}>
          <div class="add-group-or-idea-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="46" viewBox="0 0 48 46" fill="none">
              <path
                d="M36 0.0401611H12C4.8 0.0401611 0 4.84016 0 12.0402V26.4402C0 33.6402 4.8 38.4402 12 38.4402V43.5522C12 45.4722 14.136 46.6242 15.72 45.5442L26.4 38.4402H36C43.2 38.4402 48 33.6402 48 26.4402V12.0402C48 4.84016 43.2 0.0401611 36 0.0401611ZM24 29.2482C22.992 29.2482 22.2 28.4322 22.2 27.4482C22.2 26.4642 22.992 25.6482 24 25.6482C25.008 25.6482 25.8 26.4642 25.8 27.4482C25.8 28.4322 25.008 29.2482 24 29.2482ZM27.024 19.2882C26.088 19.9122 25.8 20.3202 25.8 20.9922V21.4962C25.8 22.4802 24.984 23.2962 24 23.2962C23.016 23.2962 22.2 22.4802 22.2 21.4962V20.9922C22.2 18.2082 24.24 16.8402 25.008 16.3122C25.896 15.7122 26.184 15.3042 26.184 14.6802C26.184 13.4802 25.2 12.4962 24 12.4962C22.8 12.4962 21.816 13.4802 21.816 14.6802C21.816 15.6642 21 16.4802 20.016 16.4802C19.032 16.4802 18.216 15.6642 18.216 14.6802C18.216 11.4882 20.808 8.89616 24 8.89616C27.192 8.89616 29.784 11.4882 29.784 14.6802C29.784 17.4162 27.768 18.7842 27.024 19.2882Z"
                fill="#AE94F9" />
            </svg>
          </div>
          <div class="add-group-or-idea-text">
            <div>List ideas</div>
            <div class="add-group-or-idea-popular">Popular</div>
          </div>
        </div>
        <div class="add-group-or-idea-btn" on:click={() => createBlankGroup()}>
          <div class="add-group-or-idea-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M32.0769 -0.00012207H6.23077C5.37392 -0.00012207 4.55216 0.33702 3.94627 0.937136C3.34038 1.53725 3 2.35119 3 3.19988V44.7999C3 45.6486 3.34038 46.4625 3.94627 47.0626C4.55216 47.6627 5.37392 47.9999 6.23077 47.9999H41.7692C42.6261 47.9999 43.4478 47.6627 44.0537 47.0626C44.6596 46.4625 45 45.6486 45 44.7999V12.7999C45 7.99988 36.9231 -0.00012207 32.0769 -0.00012207ZM36.9231 16.3999C34.6751 16.3956 32.5205 15.5093 30.931 13.9349C29.3415 12.3605 28.4466 10.2264 28.4423 7.99988C28.4423 7.46945 28.655 6.96074 29.0337 6.58566C29.4124 6.21059 29.926 5.99988 30.4615 5.99988C30.9971 5.99988 31.5107 6.21059 31.8894 6.58566C32.268 6.96074 32.4808 7.46945 32.4808 7.99988C32.4808 9.16683 32.9488 10.286 33.7819 11.1111C34.615 11.9363 35.7449 12.3999 36.9231 12.3999C37.4586 12.3999 37.9722 12.6106 38.3509 12.9857C38.7296 13.3607 38.9423 13.8694 38.9423 14.3999C38.9423 14.9303 38.7296 15.439 38.3509 15.8141C37.9722 16.1892 37.4586 16.3999 36.9231 16.3999ZM34 23.9995H14C13.4696 23.9995 12.9609 24.1575 12.5858 24.4389C12.2107 24.7202 12 25.1017 12 25.4995C12 25.8973 12.2107 26.2789 12.5858 26.5602C12.9609 26.8415 13.4696 26.9995 14 26.9995H34C34.5304 26.9995 35.0391 26.8415 35.4142 26.5602C35.7893 26.2789 36 25.8973 36 25.4995C36 25.1017 35.7893 24.7202 35.4142 24.4389C35.0391 24.1575 34.5304 23.9995 34 23.9995ZM14 29.9995H34C34.5304 29.9995 35.0391 30.1575 35.4142 30.4389C35.7893 30.7202 36 31.1017 36 31.4995C36 31.8973 35.7893 32.2789 35.4142 32.5602C35.0391 32.8415 34.5304 32.9995 34 32.9995H14C13.4696 32.9995 12.9609 32.8415 12.5858 32.5602C12.2107 32.2789 12 31.8973 12 31.4995C12 31.1017 12.2107 30.7202 12.5858 30.4389C12.9609 30.1575 13.4696 29.9995 14 29.9995Z"
                fill="#7F7F7F" />
            </svg>
          </div>
          <div class="add-group-or-idea-text">Blank list</div>
        </div>
      </div>
    </div>
  </Modal>
</div>
